module.exports = __webpack_public_path__ + "media/images/emblems/Rorschach.sg-fdc03c6611d442b7bfeef7a2576d11fd.png";